import React from 'react';

const ErrorMsg = ({ text }) => (
  <span className="text-errorColor text-sm font-light">{text}</span>
);

export default ErrorMsg;